import { useEffect, useState } from 'react';
import axios from 'axios';
import {
  ensureBrowserSession,
  getSessionSnapshot,
  installBrowserSession,
  logoutBrowserSession,
  subscribeSession,
  updateSessionUser,
} from '@crewmates/api-client-legacy';
import constant from '../_config/constant';

installBrowserSession({ axiosInstance: axios, baseUrl: constant.apiUrl });

export function useBrowserSession() {
  const [session, setSession] = useState(getSessionSnapshot());
  useEffect(() => {
    const unsubscribe = subscribeSession(setSession);
    ensureBrowserSession();
    return unsubscribe;
  }, []);
  return session;
}

const HOST_ACCOUNT_TYPES = ['Host', 'Both'];

// PrivateRoute and the "/" landing redirect have to agree on what counts as a host
// session. While they disagreed the app ping-ponged: "/" saw an authenticated user and
// sent it to /properties, PrivateRoute saw a non-host and redirected back to "/", and
// round it went - tens of thousands of times until the browser throttled navigation.
// Both now call this, so they cannot drift apart again.
export function isHostSession(session) {
  return Boolean(
    session &&
    session.status === 'authenticated' &&
    session.user &&
    HOST_ACCOUNT_TYPES.includes(session.user.type)
  );
}

export { ensureBrowserSession, getSessionSnapshot, logoutBrowserSession, updateSessionUser };
